export * from './select-promo-participating-product.module'
export * from './select-promo-participating-product.component'
